import reducer from './reducers';

export { default as homeOperations } from './operations';
export { default as homeTypes } from './types';
export { default as homeSelectors } from './selectors';

export default reducer;
